import { useIsFeatureEnabled } from '~/shared/lib/feature-flags'
import { TaggingLegacy } from './tagging-legacy'
import { TaggingRedesign } from './tagging-redesign'

export function Tagging() {
  const isRedesignEnabled = useIsFeatureEnabled('2026-05-tagging-redesign')

  if (isRedesignEnabled) {
    return <TaggingRedesign />
  }

  return <TaggingLegacy />
}
